module.exports = __webpack_public_path__ + "static/media/Security Made Right.648eb0f1.png";